import { Card, CardContent, CardHeader, FormLabel, Grid, Grid2, TextField } from "@mui/material";
import GridForm from "../general/GridForm";

function DataPrestasi({ handleChange, data }) {
    return (<>
        <Card>
            <CardHeader title="Data Prestasi" sx={{ borderBottom: "1px solid #f4f4f4" }}>
            </CardHeader>
            <CardContent>
                <Card>
                    <CardHeader title="Prestasi 1 (Opsional)" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                    </CardHeader>
                    <CardContent>
                        <Grid container spacing={2} sx={{ padding: "10px" }}>
                            <GridForm column={3} titleForm={"Nama Perlombaan"} attribute={{ name: "nama_perlombaan1", value: data?.nama_perlombaan1 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Jenis Lomba"} attribute={{ name: "jenis_lomba1", value: data?.jenis_lomba1 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Tingkat"} attribute={{ name: "tingkat1", value: data?.tingkat1 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Juara"} attribute={{ name: "juara1", value: data?.juara1 }} isRequired={false} handleChange={handleChange}></GridForm>
                        </Grid>
                    </CardContent>
                </Card>
                <Card sx={{ mt: '10px' }}>
                    <CardHeader title="Prestasi 2 (Opsional)" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                    </CardHeader>
                    <CardContent>
                        <Grid container spacing={2} sx={{ padding: "10px" }}>
                            <GridForm column={3} titleForm={"Nama Perlombaan"} attribute={{ name: "nama_perlombaan2", value: data?.nama_perlombaan2 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Jenis Lomba"} attribute={{ name: "jenis_lomba2", value: data?.jenis_lomba2 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Tingkat"} attribute={{ name: "tingkat2", value: data?.tingkat2 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Juara"} attribute={{ name: "juara2", value: data?.juara2 }} isRequired={false} handleChange={handleChange}></GridForm>
                        </Grid>
                    </CardContent>
                </Card>
                <Card sx={{ mt: '10px' }}>
                    <CardHeader title="Prestasi 3 (Opsional)" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                    </CardHeader>
                    <CardContent>
                        <Grid container spacing={2} sx={{ padding: "10px" }}>
                            <GridForm column={3} titleForm={"Nama Perlombaan"} attribute={{ name: "nama_perlombaan3", value: data?.nama_perlombaan3 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Jenis Lomba"} attribute={{ name: "jenis_lomba3", value: data?.jenis_lomba3 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Tingkat"} attribute={{ name: "tingkat3", value: data?.tingkat3 }} isRequired={false} handleChange={handleChange}></GridForm>
                            <GridForm column={3} titleForm={"Juara"} attribute={{ name: "juara3", value: data?.juara3 }} isRequired={false} handleChange={handleChange}></GridForm>
                        </Grid>
                    </CardContent>
                </Card>
            </CardContent>
        </Card>

    </>);
}

export default DataPrestasi;